import { render, staticRenderFns } from "./FormTemplateTableQuestion.vue?vue&type=template&id=1218abde&scoped=true&"
import script from "./FormTemplateTableQuestion.vue?vue&type=script&lang=js&"
export * from "./FormTemplateTableQuestion.vue?vue&type=script&lang=js&"
import style0 from "./FormTemplateTableQuestion.vue?vue&type=style&index=0&id=1218abde&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218abde",
  null
  
)

export default component.exports